module.exports = __webpack_public_path__ + "static/media/lBlack.c019bd43.png";